module.exports = __webpack_public_path__ + "static/img/3_1_1.653a96d3.jpg";